import Vue from "vue";
import WorkflowStepAction from "./workflowStepAction";
import WorkflowJumpTo from "./workflowStepActionJumpTo";
import {FormApplicationStatusType} from "../../../../common/enums/forms/workflowSteps/formApplicationStatusType";
import Guid from "~/helpers/guid";
import OverdueSubmissionAction from "./overdueSubmissionAction";
import FormElementConditionalRuleSet from "../conditionalRules/formElementConditionalRuleSet";

export default class WorkflowStepActionJumpToFactory {
  static create(parent: WorkflowStepAction | FormElementConditionalRuleSet | OverdueSubmissionAction): WorkflowJumpTo {
    return WorkflowStepActionJumpToFactory.createFor(parent,
      parent instanceof WorkflowStepAction || parent instanceof OverdueSubmissionAction ? 'jump_to' : 'conditional_value');
  }

  private static createFor(parent: WorkflowStepAction | FormElementConditionalRuleSet | OverdueSubmissionAction, fieldName: string) {
    const workflowJumpTo: WorkflowJumpTo = new WorkflowJumpTo();

    workflowJumpTo.defineProperty('client_id', Guid.create());
    workflowJumpTo.defineProperty('to_client_id', '');
    workflowJumpTo.defineProperty('status', String(FormApplicationStatusType.completed));

    workflowJumpTo.parent = parent;
    Vue.set(parent, fieldName, workflowJumpTo);

    return workflowJumpTo;
  }
}